/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Unsupported_Browser_MessageInputs */

const en_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In order to use ${i?.name}, you'll have to use Brave Browser. Need to install Brave Browser?`)
};

const id_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Untuk menggunakan ${i?.name}, Anda harus menggunakan Brave Browser. Perlu menginstal Brave Browser?`)
};

const ms_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Untuk menggunakan ${i?.name}, anda perlu guna Brave Browser. Perlu memasang Brave Browser?`)
};

const ca_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Per poder fer servir ${i?.name}, hauràs d'utilitzar el navegador de Brave. Necessites instal·lar el navegador de Brave?`)
};

const cs_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chcete-li používat ${i?.name}, musíte použít prohlížeč Brave. Potřebujete si prohlížeč Brave nainstalovat?`)
};

const da_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`For at kunne bruge ${i?.name} skal du bruge Brave Browser. Har du brug for at installere Brave Browser?`)
};

const de_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Um ${i?.name} nutzen zu können, musst du den Brave Browser verwenden. Möchtest du den Brave Browser installieren?`)
};

const et_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selleks, et kasutada teenust ${i?.name}, peate kasutama Brave'i brauserit. Kas installime Brave'i brauseri?`)
};

const es_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Para usar ${i?.name}, tendrás que usar el navegador de Brave. ¿Quieres instalar el navegador de Brave?`)
};

const fr_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pour utiliser ${i?.name}, vous devez utiliser le navigateur Brave. Besoin d’aide pour installer Brave ?`)
};

const hr_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kako biste koristili ${i?.name} morate koristiti preglednik Brave. Trebate instalirati preglednik Brave?`)
};

const it_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Per poter usare ${i?.name}, devi usare il browser Brave. Devi installare Brave?`)
};

const lv_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lai izmantotu ${i?.name}, jums ir nepieciešams Brave pārlūks. Vai vēlaties to instalēt?`)
};

const lt_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Norint naudoti ${i?.name}, reikia naršyklės „Brave“. Ar norite ją įdiegti?`)
};

const hu_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A ${i?.name} használatához a Brave böngészőt kell használnia. Szüksége van Brave böngészőre?`)
};

const nl_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Als je ${i?.name} wilt gebruiken, moet je de Brave-browser gebruiken. Wil je de Brave-browser installeren?`)
};

const nb_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} er bare tilgjengelig i Braves nettleser. Vil du installere Braves nettleser?`)
};

const pl_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aby móc korzystać z ${i?.name}, musisz używać przeglądarki Brave. Czy chcesz zainstalować przeglądarkę Brave?`)
};

const pt_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Para usar o ${i?.name}, você terá que usar o navegador Brave. Precisa instalar o navegador Brave?`)
};

const ro_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pentru a putea folosi ${i?.name}, va trebui să folosești Brave Browser. Ai nevoie să instalezi Brave Browser?`)
};

const sk_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ak chcete používať ${i?.name}, musíte použiť prehliadač Brave. Potrebujete nainštalovať prehliadač Brave?`)
};

const sl_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Če želite uporabljati »${i?.name}«, boste morali uporabiti brskalnik Brave. Želite namestiti brskalnik Brave?`)
};

const fi_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sinulla tulee olla Brave Browser, jotta voit käyttää kohdetta ${i?.name}. Tarvitseeko sinun asentaa Brave Browser?`)
};

const sv_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`För att kunna använda ${i?.name}måste du använda Brave-webbläsaren. Behöver du installera Brave-webbläsaren?`)
};

const vi_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Để sử dụng ${i?.name}, bạn cần sử dụng trình duyệt Brave. Cần cài đặt trình duyệt Brave?`)
};

const tr_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} hesabını kullanmak için Brave Tarayıcı kullanmanız gerekecek. Brave Tarayıcı'yı yüklemeniz mi gerekiyor?`)
};

const el_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Για να χρησιμοποιήσετε το ${i?.name}, θα πρέπει να χρησιμοποιήσετε το Brave Browser. Θέλετε να εγκαταστήσετε το Brave Browser;`)
};

const bg_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`За да използваш ${i?.name}, ще трябва да използваш браузъра Brave. Налага ли се да инсталираш Brave Браузър?`)
};

const ru_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Для использования ${i?.name} вам нужно использовать Brave Browser. Нужно установить Brave Browser?`)
};

const sr_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Да бисте користили функцију ${i?.name}, мораћете да користите Brave прегледач. Треба да инсталирате Brave прегледач?`)
};

const uk_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Для того, щоб користуватися ${i?.name}, вам потрібен браузер Brave. Хочете встановити браузер Brave?`)
};

const ka_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}-ის გამოსაყენებლად, თქვენ უნდა გამოიყენოთ Brave ბრაუზერი. გჭირდებათ Brave ბრაუზერის ინსტალაცია?`)
};

const hi_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} का इस्तेमाल करने के लिए, आपको ब्रेव ब्राउज़र का इस्तेमाल करना होगा। क्या आपको ब्रेव ब्राउज़र इंस्टॉल करना है?`)
};

const th_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เพื่อใช้ ${i?.name} คุณจะต้องใช้ Brave Browser ต้องการติดตั้ง Brave Browser หรือไม่`)
};

const ko_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}을(를) 사용하려면 Brave 브라우저를 사용해야 합니다. Brave 브라우저를 설치하셔야 하나요?`)
};

const zh_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`如要使用 ${i?.name}，您须使用 Brave 浏览器。要安装 Brave 浏览器吗?`)
};

const zh_tw_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`若要使用 ${i?.name}，您必須使用 Brave 瀏覽器。需要安裝 Brave 瀏覽器嗎？`)
};

const ja_unsupported_browser_message = /** @type {(inputs: Unsupported_Browser_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}を使用するには、Braveブラウザを使用する必要があります。Braveブラウザをインストールしますか？`)
};

/**
* | output |
* | --- |
* | "In order to use {name}, you'll have to use Brave Browser. Need to install Brave Browser?" |
*
* @param {Unsupported_Browser_MessageInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const unsupported_browser_message = /** @type {((inputs: Unsupported_Browser_MessageInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unsupported_Browser_MessageInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_unsupported_browser_message(inputs)
	if (locale === "ms") return ms_unsupported_browser_message(inputs)
	if (locale === "ca") return ca_unsupported_browser_message(inputs)
	if (locale === "cs") return cs_unsupported_browser_message(inputs)
	if (locale === "da") return da_unsupported_browser_message(inputs)
	if (locale === "de") return de_unsupported_browser_message(inputs)
	if (locale === "et") return et_unsupported_browser_message(inputs)
	if (locale === "es") return es_unsupported_browser_message(inputs)
	if (locale === "fr") return fr_unsupported_browser_message(inputs)
	if (locale === "hr") return hr_unsupported_browser_message(inputs)
	if (locale === "it") return it_unsupported_browser_message(inputs)
	if (locale === "lv") return lv_unsupported_browser_message(inputs)
	if (locale === "lt") return lt_unsupported_browser_message(inputs)
	if (locale === "hu") return hu_unsupported_browser_message(inputs)
	if (locale === "nl") return nl_unsupported_browser_message(inputs)
	if (locale === "nb") return nb_unsupported_browser_message(inputs)
	if (locale === "pl") return pl_unsupported_browser_message(inputs)
	if (locale === "pt") return pt_unsupported_browser_message(inputs)
	if (locale === "ro") return ro_unsupported_browser_message(inputs)
	if (locale === "sk") return sk_unsupported_browser_message(inputs)
	if (locale === "sl") return sl_unsupported_browser_message(inputs)
	if (locale === "fi") return fi_unsupported_browser_message(inputs)
	if (locale === "sv") return sv_unsupported_browser_message(inputs)
	if (locale === "vi") return vi_unsupported_browser_message(inputs)
	if (locale === "tr") return tr_unsupported_browser_message(inputs)
	if (locale === "el") return el_unsupported_browser_message(inputs)
	if (locale === "bg") return bg_unsupported_browser_message(inputs)
	if (locale === "ru") return ru_unsupported_browser_message(inputs)
	if (locale === "sr") return sr_unsupported_browser_message(inputs)
	if (locale === "uk") return uk_unsupported_browser_message(inputs)
	if (locale === "ka") return ka_unsupported_browser_message(inputs)
	if (locale === "hi") return hi_unsupported_browser_message(inputs)
	if (locale === "th") return th_unsupported_browser_message(inputs)
	if (locale === "ko") return ko_unsupported_browser_message(inputs)
	if (locale === "zh") return zh_unsupported_browser_message(inputs)
	if (locale === "zh-tw") return zh_tw_unsupported_browser_message(inputs)
	if (locale === "ja") return ja_unsupported_browser_message(inputs)
	return en_unsupported_browser_message(inputs)
});